<!--
  MimioContent — 워드형 본문(content_html) 렌더 컴포넌트.
  v-safe-html(DOMPurify)로 정화 후 .mimio-content 규칙(mimio-content.css)으로 표시.
  사용: <MimioContent :html="special.contentHtml" />

  레거시 호환: HTML 마이그레이션 전 평문(태그 없음)이 들어오면 줄바꿈을 보존한
  문단으로 감싸 렌더 → 마이그레이션 미적용 데이터도 깨지지 않음.
-->
<template>
  <div class="mimio-content" v-safe-html="rendered"></div>
</template>

<script>
export default {
  name: 'MimioContent',
  props: {
    html: {
      type: String,
      default: '',
    },
  },
  computed: {
    rendered() {
      const v = this.html || '';
      // TipTap 출력은 항상 블록 태그(<p>, <h2>…)로 시작 → '시작이 태그'인지로 판별.
      // (단순 /</ 검사는 "x < y", "<support@a.com>" 같은 평문을 HTML 로 오인해 DOMPurify 가 날림)
      // 태그로 시작하지 않으면 레거시 평문 → 이스케이프 후 pre-line 문단으로 래핑(줄바꿈 보존)
      if (!/^\s*<[a-zA-Z/]/.test(v)) {
        const esc = v.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        return `<p style="white-space:pre-line">${esc}</p>`;
      }
      return v;
    },
  },
};
</script>
